import React from 'react';
import styled from 'styled-components';
import { TrainingPlanWeekDetailsFragment } from '../../../graphql/types';
import { TrackingEventData } from '../../../hooks/useTracking';
import { TrainingPlanWorkout } from './TrainingPlanWorkout';

const StyledWorkoutContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

interface TrainingPlanWeekViewProps {
  week: TrainingPlanWeekDetailsFragment;
  trackingData?: TrackingEventData;
  canEdit: boolean;
}

export const TrainingPlanWeekView: React.FC<TrainingPlanWeekViewProps> = ({
  week,
  trackingData,
  canEdit,
}) => {
  return (
    <StyledWorkoutContainer
      data-testid="week-content"
      data-week-order={week.order}
    >
      {week.workouts.edges.map(({ node: workout }) => (
        <TrainingPlanWorkout
          key={workout.id}
          workout={workout}
          canEdit={canEdit}
          weekOrder={week.order}
          trackingData={trackingData}
        />
      ))}
    </StyledWorkoutContainer>
  );
};
